import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OperationType } from 'common/constants/sm-constants';
import { FeedbackStudentModel } from 'common/models/page-models/Feedback Students Model/feedback-student-data.model';
import { FeedbackStudentListingModel } from 'common/models/page-models/Feedback Students Model/feedback-student-params.model';
import { RouteEnvelope } from 'common/models/utility-models/base-model';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { FeedbackStudentWidgetService } from 'common/widget/feedback/feedback-student-widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class FeedbackStudentGridResolver extends GridResolver<FeedbackStudentModel, FeedbackStudentListingModel> {
    constructor(
        protected fs: FeedbackStudentWidgetService,
        protected override  router: Router,
        protected override  systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

//    getResolverMessage() {
//         console.log(this.router.url)
//         const route = this.manageState();
//         console.log(route);
//         const routerConfig = new RouteEnvelope();
//         routerConfig['type'] = OperationType.VIEW;
//         routerConfig['transferData'] = route['transferData'];
//         return routerConfig;
//     }

    override manageState() {

        if (this.router.getCurrentNavigation().extras.state === undefined) {
            const envelope = new RouteEnvelope();
            envelope.type = OperationType.VIEW;
            envelope.transferData = new GridParams();
            return envelope;
        } else {
            return this.router.getCurrentNavigation().extras.state;
        }

    }
}